export default {"src":"https://js-static.hirist.tech/production/2.1.23/_next/static/media/eye.ef575733.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};